import { Reveal, ChapterLabel } from "./Reveal";
import { site } from "../content";

export const Process = () => {
  const { process } = site;
  return (
    <section id="prosessi" className="py-24 md:py-32" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <ChapterLabel chapter={process.chapter} label={process.label} />
          <h2 className="mt-5 font-serif font-light text-3xl md:text-5xl tracking-tight text-[#2B2724]">
            {process.title}
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {process.steps.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.1}>
              <div
                className="relative border-t-2 border-dashed border-[#2B2724]/15 pt-8"
                data-testid={`process-step-${step.n}`}
              >
                <span
                  aria-hidden="true"
                  className="absolute -top-[9px] left-0 w-4 h-4 rounded-full bg-[#7C8C7E]"
                />
                <span className="font-serif text-6xl md:text-7xl font-light text-[#7C8C7E]/50">{step.n}</span>
                <h3 className="mt-5 font-serif text-2xl text-[#2B2724]">{step.title}</h3>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-[#5C564F]">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
